var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1338 15.4749V10.7191",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.828 7.12655C11.9865 6.93436 12.281 6.93436 12.4395 7.12655L15.0311 10.2687C15.2443 10.5272 15.0605 10.9172 14.7254 10.9172H9.54212C9.20704 10.9172 9.02317 10.5272 9.23637 10.2687L11.828 7.12655Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4396 16.6895C12.281 16.8817 11.9866 16.8817 11.8281 16.6895L9.23645 13.5473C9.02325 13.2888 9.20712 12.8988 9.54219 12.8988L14.7255 12.8988C15.0605 12.8988 15.2444 13.2888 15.0312 13.5473L12.4396 16.6895Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00011 4.37793L19.2677 4.37793",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2677 4.37793L19.2677 2",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.37793L5 2",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 19.4382L5 19.4382",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.4382L5 21.8161",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2677 19.4382L19.2677 21.8161",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginV);
export default __webpack_public_path__ + "static/media/marginV.8f15fa7ca69c6362cc99322505434a70.svg";
export { ForwardRef as ReactComponent };